import {
  useQueryStates,
  parseAsInteger,
  parseAsArrayOf,
  parseAsString,
} from 'nuqs'

export const usePaymentFiltersQueryState = () => {
  const queryStates = useQueryStates(
    {
      userId: parseAsInteger,
      status: parseAsArrayOf(parseAsString),
      eventType: parseAsArrayOf(parseAsString),
      eventSubType: parseAsArrayOf(parseAsString),
      type: parseAsArrayOf(parseAsString),
      paymentProvider: parseAsArrayOf(parseAsString),
      paymentId: parseAsInteger,
      shiftId: parseAsInteger,
      companyId: parseAsInteger,
    },
    {
      urlKeys: {
        userId: 'user-id',
        status: 'status',
        eventType: 'event-type',
        eventSubType: 'event-sub-type',
        type: 'type',
        paymentProvider: 'payment-provider',
        paymentId: 'payment-id',
        shiftId: 'shift-id',
        companyId: 'company-id',
      },
    }
  )

  return queryStates
}
